// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4948":"dd40fe5c","5200":"6f09a122","7339":"65d3f076","8042":"f2bb8880","8579":"0e9ff495","8770":"ae81545f","9080":"5681cf0a"}[chunkId] + ".chunk.css";
};